import axios from '../config/axios'

const API_BASE = '/shipment-edit-requests'

const shipmentEditRequestService = {
  list: (params = {}) => axios.get(API_BASE, { params }),
  allowedFields: (shipmentId) => axios.get(`${API_BASE}/allowed-fields/${encodeURIComponent(shipmentId)}`),
  create: (data) => axios.post(API_BASE, data),
  approve: (requestId, data) => axios.post(`${API_BASE}/${encodeURIComponent(requestId)}/approve`, data),
  reject: (requestId, data) => axios.post(`${API_BASE}/${encodeURIComponent(requestId)}/reject`, data),
}

export default shipmentEditRequestService
